module.exports = __webpack_public_path__ + "static/media/Berat.0160c40a.png";